module.exports = __webpack_public_path__ + "static/DWI20_Reg_1700x1200_Baden-a39a4b20f19fd013702a50564f88cb0a.jpeg";